import { ActionTree } from "vuex";
import { RootState } from "./state";
import { FormService } from "@/services/formService";
import axios from "axios";
import router, { FORMULAR_AUSWAHL_ROUTE_NAME } from "@/router";

import { FormValues } from "@/interfaces/FormValues";

export interface SubmissionPayload {
  formPages: { [key: string]: FormValues };
  userEmail: string;
  sequenceName: string;
}

export interface AuthenticatePayload {
  username: string;
  password: string;
}

export interface FetchBankNamePayload {
  username: string;
}

export const actions: ActionTree<RootState, RootState> = {
  async submitAllFormValues(
    { commit },
    payload: SubmissionPayload
  ): Promise<void> {
    const service = new FormService();
    await service.postValues(payload);
  },

  async myJLSAuthentication(
    { commit },
    payload: AuthenticatePayload
  ): Promise<void> {
    const URL = "https://signage.multiq.com/Loopback/api/CMSUsers/login";
    axios({
      method: "post",
      url: URL,
      data: payload,
    }).then(
      (response) => {
        if (response.status === 200) {
          commit("setMyJLSToken", response.data.id);
          commit("setUserName", payload.username);
          router.push({ name: FORMULAR_AUSWAHL_ROUTE_NAME });
        }
      },
      (error) => {
        alert(error);
        console.log("Error: ", error);
      }
    );
  },
};
